import { render, staticRenderFns } from "./appLayout.vue?vue&type=template&id=bf12f3aa&"
import script from "./appLayout.vue?vue&type=script&lang=js&"
export * from "./appLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports